/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';
import { PROVIDER_MESSAGE_SAGA } from '../reducers/app';
import { getDateFromValidityKey, isoDate } from '../utils/date-utils';

import { getCBXSocket } from '../web-socket/client';
import { fullQueuesPath } from '../navigation';

// eslint-disable-next-line require-yield
export function* saveProviderMessage(action: any) {
  const { message } = action;
  const socketClient = getCBXSocket();
  if (socketClient) {
    socketClient.send({
      cmd: 'booth/save-provider-message',
      message: message.message,
      validTo: isoDate(getDateFromValidityKey(message.validTo))
    });
    window.location.href = fullQueuesPath(socketClient.deviceUUID);
  }
}

export function* providerMessageSaga() {
  yield takeLatest(PROVIDER_MESSAGE_SAGA, saveProviderMessage);
}
